// src/components/auth/LoginForm.jsx
import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { useAuthContext } from '../../contexts/AuthContext';
import { styles } from '../../styles/theme';

/**
 * PIN Login Form Component
 */
const LoginForm = ({ onLoginSuccess }) => {  
  const { login } = useAuthContext();
  const [pinInput, setPinInput] = useState('');
  const [pinError, setPinError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setPinError('');

  try {
    // Import verifyLogin at the top if not already there
    const { verifyLogin } = await import('../../services/authService');
    
    console.log('Verifying PIN...');
    const user = await verifyLogin(pinInput);
    console.log('Login successful:', user);
    
    // Call the context login with the user data
    const result = login(pinInput, user);
    setPinInput('');
    
    // Call the callback with the role
    if (onLoginSuccess) {
      onLoginSuccess(result);
    }
  } catch (error) {
    console.error('Login error:', error);
    setPinError(error.message || 'Invalid PIN. Please try again.');
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div style={styles.loginContainer}>
      <div style={styles.loginBox}>
        <h1 style={styles.loginTitle}>🚗 Stemtree Pickup</h1>
        <p style={styles.loginSubtitle}>Enter your PIN to continue</p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="4"
            value={pinInput}
            onChange={(e) => setPinInput(e.target.value)}
            placeholder="Enter 4-digit PIN"
            style={styles.pinInput}
            autoFocus
            disabled={isLoading}
          />
          
          {pinError && (
            <div style={styles.pinError}>
              <AlertCircle size={16} />
              <span style={{ marginLeft: '8px' }}>{pinError}</span>
            </div>
          )}
          
          <button 
            type="submit" 
            style={{
              ...styles.loginButton,
              opacity: isLoading ? 0.6 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;